// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 2H1V18H23V2ZM7 10V6H9V10H7ZM11 8V6H13V8H11ZM17 10H15V6H17V10ZM11 14V9H13V14H11ZM9 14H7V11H9V14ZM15 14V11H17V14H15Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 20H3V22H21V20Z"}}]};

const SystemRegulationFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'system-regulation-filled',
    ref,
    icon: element,
  },
));

SystemRegulationFilledIcon.displayName = 'SystemRegulationFilledIcon';

export default SystemRegulationFilledIcon;
